import 'es6-shim';
import "@babel/polyfill";
import "isomorphic-fetch";

import AppAuth from '../my_portal/relay/AppAuth';
import AppAccess from '../my_portal/relay/AppAccess';

window.AppAuth = AppAuth;
window.AppAccess = AppAccess;